export default {
  nav: {
    home: '首页',
    articles: '文章',
    tech: '技术',
    software: '软件',
    tutorial: '教程',
    resource: '资源',
    news: '资讯',
    tools: '工具箱',
    about: '关于',
    sponsor: '会员',
    copyright: '版权声明'
  },
  header: {
    searchPlaceholder: '搜索文章...',
    searchMobilePlaceholder: '搜索文章、工具...',
    search: '搜索',
    navLabel: '导航',
    drawerHint: '滑动浏览 · 点按导航',
    openMenu: '打开菜单',
    closeMenu: '关闭菜单',
    langZh: '中文',
    langEn: 'EN'
  },
  footer: {
    nav: '导航',
    about: '关于',
    copyright: '版权声明',
    feedback: '反馈建议',
    followUs: '关注我们',
    channelsHint: '悬停或点击二维码可放大扫码',
    allRights: '版权所有',
    contactEmail: '联系邮箱',
    qrAlt: '{label}二维码',
    qrEnlarge: '{label}放大二维码',
    close: '关闭',
    wechatScan: '打开微信扫一扫',
    filingHint: '当前域名备案：{label}',
    filingHintEmpty: '当前域名备案'
  },
  home: {
    readMore: '阅读全文',
    noCarousel: '暂无轮播文章',
    noCarouselHint: '在后台文章管理中开启「首页轮播展示」',
    latest: '最新',
    featured: '精华',
    views: '阅读',
    softwareTitle: '软件推荐',
    softwareSubtitle: '精选实用软件，小工具、办公、开发应有尽有',
    tutorialTitle: '教程文章',
    tutorialSubtitle: '从入门到实战，系统化学习路径',
    resourceTitle: '资源分享',
    resourceSubtitle: '学习路线、开源项目、书籍推荐',
    techTitle: '技术文章',
    techSubtitle: '前端开发、工程化与性能优化',
    all: '全部',
    viewMore: '查看更多',
    techCatTitle: '{cat}技术文章',
    emptyCategory: '该分类暂无文章',
    seoIndex: '全站文章索引'
  },
  articles: {
    count: '共 {n} 篇文章',
    searchPrefix: '搜索：{q}',
    all: '全部',
    tech: '技术',
    software: '软件',
    tutorial: '教程',
    resource: '资源',
    news: '资讯',
    titleAll: '全部文章',
    titleTech: '技术文章',
    titleSoftware: '软件推荐',
    titleTutorial: '教程文章',
    titleResource: '资源分享',
    titleNews: '资讯动态',
    subCategory: '子分类',
    softwareCats: '软件分类',
    tutorialCats: '教程分类',
    resourceCats: '资源分类',
    techCats: '技术分类',
    tags: '标签',
    empty: '没有找到相关文章',
    featured: '精华'
  },
  article: {
    home: '首页',
    body: '正文',
    back: '返回',
    repostFrom: '转载自：',
    readMinutes: '约 {n} 分钟',
    readAbout: '读完约',
    views: '阅读',
    copyLink: '复制链接',
    loadingBody: '正在加载正文…',
    thanks: '感谢阅读',
    moreType: '更多{type}',
    related: '相关推荐',
    loading: '正在加载文章…',
    notFound: '文章不存在',
    backToList: '返回文章列表',
    translationFallback: '暂无英文译文，显示中文原文',
    original: '原创',
    repost: '转载',
    publishedAt: '发布于 {date}',
    updatedAt: '更新于 {date}',
    publish: '发布',
    update: '更新',
    copied: '链接已复制',
    copyFailed: '复制失败',
    uncategorized: '未分类',
    authorDefault: '博主',
    recommend: '推荐文章',
    hotTags: '热门标签',
    thisArticle: '本文信息',
    category: '分类',
    authorBio: '专注技术分享与内容创作',
    updatedShort: '更',
    list: '文章列表'
  },
  friendLinks: {
    title: '友情链接',
    subtitle: '与优秀站点互联互通'
  },
  share: {
    label: '分享',
    copyTo: '复制链接分享到{name}',
    preview: '卡片预览',
    collapse: '收起预览',
    copied: '已复制',
    copyLink: '复制链接',
    previewTip: '粘贴到微信、QQ 等平台时将显示以上卡片样式',
    wechat: '微信',
    qq: 'QQ',
    weibo: '微博'
  },
  lock: {
    login: '登录可见',
    member: '会员专享',
    paid: '付费内容',
    public: '公开',
    loginMsg: '登录后即可阅读本节内容',
    memberMsg: '开通会员后可阅读会员专享内容',
    paidMsg: '使用 {n} {name} 解锁本节内容',
    paidMsgPlain: '使用{name}解锁本节内容',
    myPoints: '我的{name}：',
    insufficient: '（不足 {n}）',
    loginRead: '立即登录阅读',
    openMember: '开通赞助会员',
    unlock: '{n} {name} 解锁',
    getPoints: '获取{name}',
    loginFirst: '先登录'
  },
  tools: {
    badge: '在线工具箱',
    heroTitle: '实用工具，即开即用',
    heroDesc: 'PDF、图片、码制、站长、生活、运维与配置转换 — 全部在浏览器本地处理，安全快捷，无需上传服务器。',
    countTools: '款工具',
    countCats: '大分类',
    localPct: '本地处理',
    searchPlaceholder: '搜索工具，如 PDF 合并、二维码…',
    frequent: '常用工具',
    frequentHintLogin: '按你的使用习惯同步到账号，置顶可优先显示',
    frequentHintGuest: '本机记录最近使用；登录后可跨设备同步',
    clear: '清空',
    clearConfirm: '确定清空常用工具记录？',
    cleared: '已清空',
    pin: '置顶',
    unpin: '取消置顶',
    removeFrequent: '从常用移除',
    frequentEmpty: '使用过的工具会出现在这里，点击即可直达',
    all: '全部',
    toolsInCat: '{n} 个工具',
    empty: '没有找到匹配的工具',
    notFound: '工具不存在',
    backHub: '返回工具箱',
    allTools: '全部工具',
    loginRequired: '登录后使用',
    loginTip: '该工具需要登录账号后才能使用，登录后可在浏览器本地安全处理文件。',
    loginNow: '立即登录',
    tip: '提示'
  },
  about: {
    browseArticles: '浏览文章',
    contactMe: '联系我',
    role: '前端开发者 · 技术写作者',
    bio1: '一名热爱技术的前端开发者，专注于 Web 前端工程化与用户体验设计。这个博客是我记录学习笔记、技术思考、软件推荐与项目经验的地方。',
    bio2: '希望把复杂的技术问题讲清楚，把好用的工具分享给大家，让每一次阅读都有所收获。',
    online: '在线创作中',
    focusEyebrow: 'FOCUS',
    focusTitle: '我在做什么',
    focusSub: '用写作沉淀经验，用分享连接更多开发者',
    focusWrite: '技术写作',
    focusWriteDesc: '分享前端开发经验、工程化实践与性能优化思路，把复杂问题讲清楚。',
    focusTools: '工具推荐',
    focusToolsDesc: '精选实用软件与小工具，提升日常开发与学习效率。',
    focusTutorial: '教程实战',
    focusTutorialDesc: '从入门到进阶的项目教程，帮助读者建立完整的知识体系。',
    contentEyebrow: 'CONTENT',
    contentTitle: '博客内容方向',
    contentSub: '四大栏目，覆盖从入门到进阶的学习路径',
    techDesc: '前端开发、性能优化、工程实践',
    softwareDesc: '小工具、办公与开发效率软件',
    tutorialDesc: '入门到进阶的系统化学习',
    resourceDesc: '学习资料、开源项目与书籍',
    statArticles: '文章总数',
    statTech: '技术文章',
    statSoftware: '软件推荐',
    statTutorialResource: '教程 & 资源',
    techGroupFront: '前端框架',
    techGroupLang: '语言与样式',
    techGroupEng: '工程化',
    techGroupOther: '其他',
    tagEng: '工程化',
    tagUx: '用户体验',
    articleCount: '{n} 篇文章',
    stackTitle: '技术栈',
    stackSub: '日常开发与技术写作中频繁使用的工具与框架',
    ctaTitle: '一起交流，共同进步',
    ctaDesc: '欢迎通过邮件交流技术问题、合作事宜或内容建议。也欢迎关注与支持本站持续创作。',
    sponsorSupport: '赞助支持'
  },
  sponsor: {
    badge: '赞助会员',
    title: '支持{name}，解锁更多优质内容',
    desc: '您的赞助将帮助站点持续更新教程、软件推荐与技术文章。选择合适方式开通或续费会员。',
    memberUntil: '当前赞助有效期至',
    renewNote: '续费将在到期日基础上延长',
    plansRenew: '续费套餐',
    plansBuy: '会员套餐',
    plansDirectTip: '选择套餐完成赞助，支付成功后自动开通会员',
    plansExternalTip: '选择合适套餐前往发卡平台购买，购买后返回本站兑换 CDK 激活',
    plansIntroTip: '以下为会员套餐介绍，购买后请使用兑换码激活',
    originalPrice: '原价 ¥{price}',
    unitPrice: '折合 {unit}',
    renew: '续费',
    sponsorNow: '立即赞助',
    goBuy: '前往购买',
    onlineBuy: '在线购买会员',
    empty: '会员购买功能暂未开放，请联系管理员',
    faqTitle: '常见问题'
  },
  profile: {
    member: '赞助会员',
    normalUser: '普通用户',
    joinedAt: '加入于 {date}',
    memberUntil: '赞助至 {date}',
    changeAvatar: '更换头像',
    admin: '系统后台',
    renew: '续费赞助',
    openSponsor: '开通赞助',
    history: '浏览记录',
    orders: '订单',
    unlocked: '已解锁',
    sideLabel: '账户中心',
    navAria: '个人中心导航',
    tabInfo: '个人信息',
    tabInfoShort: '资料',
    tabSecurity: '账号安全',
    tabSecurityShort: '安全',
    tabHistory: '浏览历史',
    tabHistoryShort: '历史',
    tabPoints: '我的积分',
    tabPointsShort: '积分',
    tabMember: '赞助会员',
    tabMemberShort: '会员',
    tabOrders: '赞助订单',
    tabOrdersShort: '订单',
    guestTitle: '登录后管理个人中心',
    guestDesc: '同步浏览历史、积分签到、赞助会员与订单记录',
    loginNow: '立即登录'
  },
  copyright: {
    backHome: '返回首页',
    title: '版权声明',
    desc: '欢迎访问「{name}」网站。请仔细阅读以下条款，使用本站即表示您已阅读并同意本声明的全部内容。',
    updated: '最后更新：2026 年 3 月 10 日',
    effective: '生效日期：2026 年 1 月 1 日',
    toc: '目录',
    contactPrefix: '如您对本声明有任何疑问，请通过邮箱',
    contactSuffix: '与我们联系。我们将在合理期限内予以回复。',
    enNotice: '英文版本仅供参考；如与中文内容不一致，以中文为准。'
  },
  redirect: {
    back: '返回上一页',
    leaving: '即将离开本站',
    invalid: '链接无效',
    leavingDesc: '您即将访问第三方网站，请确认目标地址后再继续。',
    invalidDesc: '无法识别或解析该链接，请检查地址是否正确。',
    targetSite: '目标网站',
    copy: '复制',
    copied: '已复制',
    linkName: '链接名称',
    fromArticle: '来源文章',
    safety: '安全提示',
    tip1: '第三方网站的内容、隐私政策与安全措施由该网站自行负责。',
    tip2: '请勿在未知页面输入账号、密码或支付信息。',
    tip3: '如遇可疑页面，请立即关闭并返回本站。',
    cancel: '取消返回',
    confirm: '确认前往',
    countdown: '点击确认后将在新标签页打开目标链接，本站页面保持不变',
    invalidReason: '可能原因：链接格式错误、协议不受支持，或缺少跳转参数。',
    backHome: '返回首页',
    footerTip: '{name} 对外链访问进行安全提示，保护您的浏览体验'
  },
  common: {
    langSwitched: '已切换语言',
    tip: '提示'
  },
  auth: {
    login: '登录',
    logout: '退出登录',
    loggedOut: '已退出登录',
    register: '注册',
    createAccount: '创建账号',
    welcomeBack: '欢迎回来',
    joinUs: '加入我们',
    forgotTitle: '找回密码',
    welcomeDesc: '登录账号，继续你的阅读之旅',
    registerDesc: '创建账号，探索更多优质内容',
    qrDesc: '微信扫码，安全快捷登录网站',
    forgotDesc1: '通过注册邮箱验证身份，安全重置您的密码',
    forgotDesc2: '设置新密码后即可重新登录账号',
    featCollect: '收藏喜欢的文章',
    featHistory: '同步浏览历史记录',
    featPersonal: '个性化阅读体验',
    featEmail: '邮箱验证保障账号安全',
    featCode: '验证码 10 分钟内有效',
    featReset: '重置后可立即登录',
    passwordLogin: '账号登录',
    qrLogin: '小程序扫码',
    account: '账号',
    accountPh: '用户名或邮箱',
    password: '密码',
    passwordPh: '请输入密码',
    forgot: '忘记密码？',
    noAccount: '还没有账号？',
    registerNow: '立即注册',
    hasAccount: '已有账号？',
    loginNow: '立即登录',
    backLogin: '返回登录',
    username: '用户名',
    usernamePh: '须大于 5 位',
    email: '邮箱',
    emailCode: '邮箱验证码',
    codePh: '6 位验证码',
    getCode: '获取验证码',
    resendIn: '{n}s 后重发',
    resend: '重新发送',
    passwordRule: '须大于 8 位',
    confirmPassword: '确认密码',
    confirmPh: '再次输入密码',
    forgotHint1: '输入注册邮箱，获取验证码',
    forgotHint2: '设置您的新密码',
    registeredEmail: '注册邮箱',
    registeredEmailPh: '请输入注册时使用的邮箱',
    sendCode: '发送验证码',
    code: '验证码',
    newPassword: '新密码',
    newPasswordPh: '至少 6 位',
    qrAlt: '扫码登录',
    qrLoading: '二维码加载中…',
    qrExpired: '已过期，点击刷新',
    qrRefresh: '刷新二维码',
    qrPending: '请使用微信扫一扫打开小程序并确认登录',
    qrExpiredHint: '二维码已过期，请刷新',
    qrCancelled: '已取消，可刷新后重试',
    qrError: '二维码加载失败',
    rememberPassword: '想起密码了？',
    resetPassword: '重置密码',
    confirmNewPassword: '确认新密码',
    confirmNewPh: '再次输入新密码'
  },
  user: {
    menu: '用户菜单',
    member: '赞助会员',
    normal: '普通用户',
    expireUntil: '有效期至 {date}',
    openHint: '开通赞助解锁更多内容',
    checkin: '签到',
    checkinDaily: '每日签到',
    checkedIn: '已签到',
    checkedInToday: '今日已签到',
    checkinReward: '签到可得 +{n} {name}',
    profile: '个人中心',
    myPoints: '我的积分',
    history: '浏览历史',
    recent: '最近浏览',
    viewAll: '查看全部',
    noHistory: '还没有浏览记录',
    justNow: '刚刚',
    minutesAgo: '{n} 分钟前',
    hoursAgo: '{n} 小时前',
    streak: '已连续 {n} 天'
  }
}
